import { render } from "./alert-errors.vue?vue&type=template&id=f6b370d0"
import script from "./alert-errors.vue?vue&type=script&lang=js"
export * from "./alert-errors.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__